import { useState, useEffect } from "react";
import { loadReturnIndentCode } from "../services/returnIndentServise";

const useReturnIndentNumber = (editID) => {
    const [returnIndentNumber, setReturnIndentNumber] = useState([]);
    const [isMaterialCodeDataLoaded, setIsMaterialCodeDataLoaded] = useState(false);

    // Fetch department data
    const fetchReturnIndentNumber = async (selectedID = null) => {

        const para = { p_companyid: localStorage.getItem("companyid") ,p_plantid:1};

        try {
            const data = await loadReturnIndentCode(para);
            if (data && data.length > 0) {
                setReturnIndentNumber(data[0].return_issue_indent_number);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isMaterialCodeDataLoaded && editID === 0) {
            fetchReturnIndentNumber();
        }
    }, [isMaterialCodeDataLoaded, editID]);

    // Function to load department based on selected ID
    const loadReturnIndentNumberByID = async (selectedID) => {
        await setReturnIndentNumber(selectedID);
    };

    return {
        returnIndentNumber,
        setReturnIndentNumber,
        loadReturnIndentNumberByID,
    };
};

export default useReturnIndentNumber;
